module.exports = __webpack_public_path__ + "img/exchangeUni.07e6bd30.png";